
const rolls = [
  {
    "title": "California Rolls",
    "price": "$5.990",
    "tags": [" Pollo |", " Queso Crema |", " Cebollín "]
  },
  {
    "title": "Crispy Roll",
    "price": "$6.990",
    "tags": [" Tempura |", " Salmón |", "Queso Crema "]
  },
  {
    "title": "Veggie Roll",
    "price": "$5.990",
    "tags": [" Champiñón |", " Palta |", " Queso Crema "]
  },
  {
    "title": "Vegan Roll",
    "price": "$6.990",
    "tags": [" Palta |" , " Zanahoria |" , " Cebollín" ]
  },
  {
    "title": "Hosomaki",
    "price": "$3.990",
    "tags": [" Nory |" , " Proteína |" , " Verdura " ]
  },
];

const promos = [
  {
    "title": "30 piezas",
    "price": "$14.990",
    "tags": [" Queso Crema |" , " Palta |" , " Camarón " ]
  },
  {
    "title": "50 piezas",
    "price": "$22.990",
    "tags": [" Queso Crema |" , " Palta |" , " Camarón " ]
  },
  {
    "title": "70 piezas",
    "price": "$28.990",
    "tags": [" Cebollín |" , " Pollo |" , " Queso Crema" ]
  },
  {
    "title": "90 piezas",
    "price": "$36.990",
    "tags": [" Palta |" , " Camarón |" , " Nory " ]
  },
];

export default { rolls, promos };
